import React from "react";
import RegexTextField, { RegexTextFieldProps } from "./RegexTextField";
/*
Here are the international phone number formats for Germany, Switzerland, Italy, and France, including the minimum and maximum digits:

Germany:
Format: +49 AA NNNNNNNN
Minimum digits: 8 (excluding the country code)
Maximum digits: 11 (excluding the country code)
Example: +49 30 12345678

Switzerland:
Format: +41 AA NNN NN NN
Minimum digits: 9 (excluding the country code)
Maximum digits: 12 (excluding the country code)
Example: +41 44 668 18 00

Italy:
Format: +39 AA NNNNNNN
Minimum digits: 8 (excluding the country code)
Maximum digits: 10 (excluding the country code)
Example: +39 06 1234567

France:
Format: +33 A NN NN NN NN
Minimum digits: 9 (excluding the country code)
Maximum digits: 9 (excluding the country code)
Example: +33 1 23 45 67 89
*/
const regexp = new RegExp(/^\+\d{1,3}(\s*\d){8,12}$/);

const PhoneNoTextField: React.FC<RegexTextFieldProps> = ({
  label,
  onChange,
  onChangeIsValid,
  required,
  value,
  placeholder,
}) => (
  <RegexTextField
    label={label}
    onChange={onChange}
    onChangeIsValid={onChangeIsValid}
    value={value}
    required={required}
    validationRegex={regexp}
    placeholder={placeholder}
  />
);

export default PhoneNoTextField;
